import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @param {(message: string, type?: string) => void} showToast
 */
export function useTranslatedToast(showToast) {
  const { t } = useTranslation();
  return useCallback(
    (key, type = 'info', vars = {}) => {
      showToast(t(key, vars), type);
    },
    [showToast, t]
  );
}
